import styles from "./index.module.scss";

const Bg = () => {
  return (
    <div className={styles["bg"]}></div>
  )
}

export default Bg;